import { Component, Input, OnInit } from '@angular/core'
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms'
import { MatDialog } from '@angular/material/dialog'
import { CommonModule } from '@angular/common'
import { FollowupDialogComponent } from '../followup-dialog/followup-dialog.component'
import { FollowUpService } from '../../../followup.service'
import { ToastrService } from 'ngx-toastr'
import { ActivatedRoute } from '@angular/router'
import { AuthStateService } from '../../../../../auth-state.service'

@Component({
  selector: 'app-followup',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule],
  templateUrl: './followup.component.html',
  styleUrls: ['./followup.component.css'],
})
export class FollowupComponent implements OnInit {
  @Input() quotationId: any
  followUpForm: FormGroup = new FormGroup({})
  followUpDetails: any[] = []
  permissions: string[] = []

  constructor(
    private fb: FormBuilder,
    private dialog: MatDialog,
    private followUpService: FollowUpService,
    private toastr: ToastrService,
    private route: ActivatedRoute,
    private authStateService: AuthStateService,
  ) {
    this.authStateService.permissions.subscribe((permList) => {
      this.permissions = permList
    })
  }

  ngOnInit(): void {
    this.followUpForm = this.fb.group({
      followUpDate: [new Date().toISOString().split('T')[0]],
      nextFollowUpDate: [
        new Date(new Date().setDate(new Date().getDate() + 7))
          .toISOString()
          .split('T')[0],
      ],
      followUpDetails: [''],
      followUpRemarks: [''],
    })

    this.route.paramMap.subscribe((params) => {
      

      this.quotationId = params.get('id')
    })
    this.followUpService.getQuotationFollowUps(this.quotationId).subscribe({
      next: (data: any) => {
        this.followUpDetails = data.map(function (item: any) {
          

          return {
            ...item,
            followUpDate: item.followUpDate,
            nextFollowUpDate: item.nextFollowUpDate,
            followUpDetails:
              item.followUpDetails !== null && item.followUpDetails !== ''
                ? item.followUpDetails
                : '-',
            followUpRemarks:
              item.followUpRemarks !== null && item.followUpRemarks !== ''
                ? item.followUpRemarks
                : '-',
          }
        })
      },
      error: (error: any) => {
        this.toastr.error(error.statusText, 'Error', { timeOut: 15000,
  closeButton: true,
  progressBar: true, })
      },
    })
  }

  hasPermission(action: string): boolean {
    return this.permissions.includes(action)
  }

  openFollowUpDialog(): void {
    const dialogRef = this.dialog.open(FollowupDialogComponent, {
      data: {
        followUpForm: this.followUpForm,
        mode: 'add',
      },
    })

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        result['quotationId'] = this.quotationId
        this.followUpService.addFollowUp(result).subscribe({
          next: () => {
            this.followUpDetails.push(result)
            this.toastr.success('Follow up added successfully!', 'Success')
          },
          error: (error: any) => {
            this.toastr.error(error.statusText, 'Error', { timeOut: 15000,
  closeButton: true,
  progressBar: true, })
          },
        })
      }
    })
  }

  editFollowUp(followUp: any): void {
    const dialogRef = this.dialog.open(FollowupDialogComponent, {
      data: {
        followUpForm: this.fb.group({
          followUpDate: [followUp.followUpDate.split('T')[0]],
          nextFollowUpDate: [followUp.nextFollowUpDate.split('T')[0]],
          followUpDetails: [
            followUp.followUpDetails === '-' ? '' : followUp.followUpDetails,
          ],
          followUpRemarks: [
            followUp.followUpRemarks === '-' ? '' : followUp.followUpRemarks,
          ],
        }),
        mode: 'update',
      },
    })

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        result.id = followUp.id
        result.quotationId = followUp.quotationId
        this.followUpService.updateFollowUp(result).subscribe({
          next: () => {
            const index = this.followUpDetails.findIndex(
              (f) => f.id === followUp.id,
            )
            this.followUpDetails[index] = { ...followUp, ...result }
            this.toastr.success('Follow up updated successfully!', 'Success')
          },
          error: (error: any) => {
            this.toastr.error(error.statusText, 'Error', { timeOut: 15000,
  closeButton: true,
  progressBar: true, })
          },
        })
      }
    })
  }
}
